import {
  POST_TRANSPORTCOMPANIES_CATALOG,
  POST_TRANSPORTCOMPANIES_CATALOG_ERROR,
  POST_TRANSPORTCOMPANIES_CATALOG_SUCCESS,
} from '../../../../constants/constantsRed';

export const postTransportCompaniesCatalogRed = (
  state: any = false,
  actions: any
) => {
  switch (actions.type) {
    case POST_TRANSPORTCOMPANIES_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case POST_TRANSPORTCOMPANIES_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case POST_TRANSPORTCOMPANIES_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
